import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BoxProps } from '@mui/material';

import { Divider, Label, Section } from './NewCommentsDivider.styles';

type Props = BoxProps & { label?: string };

const NewCommentsDivider: FC<Props> = ({ className, label, ...props }) => {
  const { t } = useTranslation();

  return (
    <Section className={className} {...props}>
      <Divider />
      <Label>{label ?? t('New Comments')}</Label>
    </Section>
  );
};

export default NewCommentsDivider;
